import { motion } from "framer-motion";

interface ExecutiveSummaryProps {
  text: string;
}

export function ExecutiveSummary({ text }: ExecutiveSummaryProps) {
  if (!text) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay: 0.1 }}
      className="surface p-5 relative"
    >
      <span className="absolute top-3 left-3 w-1.5 h-1.5 rounded-full bg-primary animate-pulse-led" />
      <p className="path-chip ml-5">executive summary</p>
      <p className="mt-3 text-sm text-text/85 leading-relaxed whitespace-pre-line">
        {text}
      </p>
    </motion.div>
  );
}
